//import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'slick-carousel/slick/slick.css';
import Header from './header/header.js';
import Footer from './footer/footer.js'
import Home from './home/home.js';
import Area from './area/area.js';
import golfwithhotel from './golfwithhotel/golfwithhotel.js'



import {  BrowserRouter as Router,  Switch,  Route,  Link} from "react-router-dom";




function App() {
  return (
    <div className="App">
      

    <Router>
    <Header />  
      <Switch>
    

		 <Route path="/" exact component={Home} />
		<Route path="/area" component={Area} />
		<Route path="/golfwithhotel" component={golfwithhotel} />


		</Switch>
    </Router>


     
      <Footer/>

    </div>
  );
}

export default App;
 